import SolicitacaoReembolsoTerceiro from './componentes/SolicitacaoReembolsoTerceiro.vue';
import SolicitacaoReembolsoTerceiroLista from './componentes/SolicitacaoReembolsoTerceiroLista.vue';
import SolicitacaoReembolsoTerceiroForm from './componentes/SolicitacaoReembolsoTerceiroForm.vue';
import SolicitacaoReembolsoTerceiroRelatorio from './componentes/SolicitacaoReembolsoTerceiroRelatorio.vue';

export default {
  path: '/solicitacao-reembolso-terceiro',
  component: SolicitacaoReembolsoTerceiro,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoReembolsoTerceiroLista,
      name: 'solicitacao-reembolso-terceiro',
    },
    {
      path: 'nova',
      component: SolicitacaoReembolsoTerceiroForm,
      name: 'solicitacao-reembolso-terceiro.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoReembolsoTerceiroRelatorio,
      name: 'solicitacao-reembolso-terceiro.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoReembolsoTerceiroForm,
      name: 'solicitacao-reembolso-terceiro.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-terceiro/rotas.js